import PropTypes from 'prop-types';

export const validTagValues = ['optional', 'required'] as const;
export type tagValues = typeof validTagValues[number];

export default {
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  info: PropTypes.string,
  error: PropTypes.string,
  help: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  valid: PropTypes.bool,
  validated: PropTypes.bool,
  isEmptyAndOptional: PropTypes.bool,
  isCompact: PropTypes.bool,
  tag: PropTypes.oneOf(validTagValues),

  //redux-formo methods
  blur: PropTypes.any,
  change: PropTypes.any,
  filter: PropTypes.any,
  focus: PropTypes.any,
  initialise: PropTypes.any,
  validate: PropTypes.any,

  //redux-form props
  active: PropTypes.any,
  filtered: PropTypes.any,
  filtering: PropTypes.any,
  initialised: PropTypes.any,
  lastValidValue: PropTypes.any,
  validating: PropTypes.any
};
